import React from "react";

/**
 * Back / left arrow icon
 */
export const BackIcon = ({ className = "back-icon", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 24"
    {...props}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 5l-8 7 8 7M26 12H10"
    />
  </svg>
);

/**
 * Right arrow icon (used on lifecycle cards)
 */
export const ArrowRightIcon = ({ className = "wf-arrow", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 24"
    {...props}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 5l8 7-8 7M4 12h18"
    />
  </svg>
);



export const ResetIcon = ({ className = "wf-arrow", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 24"
    {...props}
  >
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
    <path d="M3 3v5h5"></path>
  </svg>
);

export const TrustIcon = ({ className = "wf-arrow", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check text-indigo-600" aria-hidden="true"> */}
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
    <path d="m9 12 2 2 4-4"></path>
  </svg>
);

export const ApiTransferIcon = ({ className = "wf-arrow", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3.5" y="2.5" width="17" height="17" rx="2.5" />
    <path d="M3.5 6.5h17" />
    <path d="M5.3 4.5h.01" />
    <path d="M7 4.5h.01" />
    <path d="M8.7 4.5h.01" />
    <path d="M11.5 4.5h4.8" />

    <path d="M8.4 11.8l1-3 1 3" />
    <path d="M8.75 10.8h1.3" />
    <path d="M11.5 11.8V8.8h1a1 1 0 0 1 0 2h-1" />
    <path d="M14.9 8.8v3" />
    <path d="M14.2 11.8h1.4" />

    <path d="M8.5 20v-4.5" />
    <path d="M7.1 16.9l1.4-1.4 1.4 1.4" />

    <path d="M15.5 15.5V20" />
    <path d="M14.1 18.6l1.4 1.4 1.4-1.4" />
  </svg>
);


export const EmailIcon = ({ className = "wf-arrow", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 24"
    {...props}
  >
    <rect width="20" height="16" x="2" y="4" rx="2"></rect><path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7">
    </path>
  </svg>
);


export const HardwareIcon = ({ className = "wf-hardware", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    {/* Chip body */}
    <rect
      x="7"
      y="7"
      width="10"
      height="10"
      rx="2"
      strokeWidth="2"
    />

    {/* Pins */}
    <line x1="9" y1="2" x2="9" y2="6" strokeWidth="2" strokeLinecap="round" />
    <line x1="15" y1="2" x2="15" y2="6" strokeWidth="2" strokeLinecap="round" />

    <line x1="9" y1="18" x2="9" y2="22" strokeWidth="2" strokeLinecap="round" />
    <line x1="15" y1="18" x2="15" y2="22" strokeWidth="2" strokeLinecap="round" />

    <line x1="2" y1="9" x2="6" y2="9" strokeWidth="2" strokeLinecap="round" />
    <line x1="18" y1="9" x2="22" y2="9" strokeWidth="2" strokeLinecap="round" />

    <line x1="2" y1="15" x2="6" y2="15" strokeWidth="2" strokeLinecap="round" />
    <line x1="18" y1="15" x2="22" y2="15" strokeWidth="2" strokeLinecap="round" />
  </svg>
);


/**
 * Individual lifecycle icons
 */
export const DataManagementIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 6c0-1.1 3.6-2 8-2s8 .9 8 2-3.6 2-8 2-8-.9-8-2zm0 4v6c0 1.1 3.6 2 8 2s8-.9 8-2v-6m-16 6c0 1.1 3.6 2 8 2s8-.9 8-2M8 12l2 2 2-2m0 0l2 2 2-2"
    />
  </svg>
);

export const PolygonIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Polygon shape */}
    <polygon points="5 4 19 7 17 19 7 17" />

    {/* Vertices */}
    <circle cx="5" cy="4" r="1" />
    <circle cx="19" cy="7" r="1" />
    <circle cx="17" cy="19" r="1" />
    <circle cx="7" cy="17" r="1" />
  </svg>
);

export const MenuSquareIcon = ({
  className = "w-6 h-6 text-purple-600",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Outer rounded square (outline only) */}
    <rect x="4" y="4" width="16" height="16" rx="4" />

    {/* Three horizontal bars */}
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="8" y1="14" x2="16" y2="14" />
    <line x1="8" y1="18" x2="16" y2="18" />
  </svg>
);


export const TaskCollections = ({
  className = "w-6 h-6",
  ...props
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    {...props}
  >
    {/* Back L-shape with extended vertical arm */}
    <path d="M10 3h11v8h-2V5h-9V3z" />

    {/* Middle L-shape with extended vertical arm */}
    <path d="M7 6h10v8h-2V8H7V6z" />

    {/* Front card moved left */}
    <rect x="2" y="9" width="12" height="10" />
  </svg>
);

export const CloneIcon = ({
  className = "w-6 h-6",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
  </svg>
);


export const LocationIcon = ({
  className = "w-6 h-6",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);


export const ModelTrainingIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3
         M3 13h18
         M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);



export const ModelEvaluationIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 17l4-4 3 3 5-6 4 5M4 4h16M4 8h10"
    />
  </svg>
);

export const ModelDeploymentIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 16a4 4 0 010-8 5 5 0 019.6-1.1A4.5 4.5 0 1117 16h-4m0 0l2-2m-2 2l-2-2m2 2v5"
    />
  </svg>
);

export const FullCycleIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 12a8 8 0 0113-6l-1-3m1 3h-4m6 6a8 8 0 01-13 6l1 3m-1-3h4"
    />
  </svg>
);













// Datasets – stacked disks
export const DatasetIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    {/* top ellipse */}
    <ellipse
      cx="12"
      cy="5"
      rx="7"
      ry="3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* middle “layer” */}
    <path
      d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* bottom “layer” */}
    <path
      d="M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Experiments – lab flask
export const ExperimentIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    {/* neck of flask */}
    <path
      d="M10 3h4M11 3v5l-4.5 7.5A3 3 0 0 0 9 20h6a3 3 0 0 0 2.5-4.5L13 8V3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* liquid line */}
    <path
      d="M8 14h8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* bubbles */}
    <circle cx="10" cy="11" r="0.8" fill="currentColor" />
    <circle cx="14" cy="12.5" r="0.8" fill="currentColor" />
  </svg>
);





export const CalendarIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    {/* Outer calendar box */}
    <rect
      x="3"
      y="4"
      width="18"
      height="17"
      rx="2"
      ry="2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Top bar */}
    <path
      d="M3 9h18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Rings */}
    <path
      d="M8 2v4M16 2v4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* A couple of small date dots */}
    <circle cx="9" cy="13" r="1" fill="currentColor" />
    <circle cx="13" cy="13" r="1" fill="currentColor" />
    <circle cx="17" cy="13" r="1" fill="currentColor" />
  </svg>
);




export const CreateProject = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    width="90"
    height="90"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#888"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 7h18"></path>
    <path d="M3 7l2-3h14l2 3"></path>
    <path d="M3 7v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7"></path>
    <path d="M12 11v6"></path>
    <path d="M9 14h6"></path>
  </svg>
);


export const AddDatasetIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Cloud (same rounded shape, open at the bottom) */}
    <path d="M7 15a3 3 0 0 1 0-6 4 4 0 0 1 7.5-1.5A3 3 0 0 1 19 15" />

    {/* Up arrow coming into the cloud */}
    <path d="M12 18v-5" />
    <path d="M10.5 14.5L12 13l1.5 1.5" />
  </svg>
);


export const CompareVersionsIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Curved line starting from right side of bottom O, moving away & up */}
    <path d="M13.5 18C17 16 18.5 13 17 10S16 5 18 3" />

    {/* Bottom version (O) */}
    <circle cx="12" cy="18" r="1.5" />

    {/* Middle version (O) sitting on the curve */}
    <circle cx="17" cy="10" r="1.5" />
  </svg>
);





export const EditIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 26 26"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M13 21h8" />
    <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
  </svg>
);


export const DeleteIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  style,
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    style={style}
    fill="none"
    viewBox="0 0 26 26"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);


export const DownloadIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    {/* Arrow */}
    <path d="M12 4v12" />
    <path d="M8 12l4 4 4-4" />

    {/* Base line */}
    <path d="M4 20h16" />
  </svg>
);


export const TenantIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
    <path d="M10 6h4"></path>
    <path d="M10 10h4"></path>
    <path d="M10 14h4"></path>
    <path d="M10 18h4"></path>
  </svg>
);


export const UsersIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    {/* Arrow */}
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <circle cx="9" cy="7" r="4"></circle>
  </svg>
);



export const CreditcardIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <rect width="20" height="14" x="2" y="5" rx="2"></rect>
    <line x1="2" x2="22" y1="10" y2="10"></line>
  </svg>
);


export const LinkIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path d="M15 3h6v6"></path>
    <path d="M10 14 21 3"></path>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
  </svg>
);



export const HistoryTimeIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
    <path d="M3 3v5h5"></path>
    <path d="M12 7v5l4 2"></path>
  </svg>
);


export const CircleTimeIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path d="M12 6v6l4 2"></path>
    <circle cx="12" cy="12" r="10"></circle>
  </svg>
);



export const MenuIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <rect width="7" height="7" x="3" y="3" rx="1"></rect>
    <rect width="7" height="7" x="14" y="3" rx="1"></rect>
    <rect width="7" height="7" x="14" y="14" rx="1"></rect>
    <rect width="7" height="7" x="3" y="14" rx="1"></rect>
  </svg>
);


export const ExportIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Corner arrow */}
    <path d="M14 7h5v5" />
    <path d="M19 7l-7 7" />

    {/* Smooth thin curve */}
    <path d="M5 20c3 0 6-1 11-2" />
  </svg>
);


export const AddToHubIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Hub grid */}
    <path d="M5 5h5v5H5z" />
    <path d="M14 5h5v5h-5z" />
    <path d="M5 14h5v5H5z" />

    {/* Add (+) into hub */}
    <path d="M14 16h6" />
    <path d="M17 13v6" />
  </svg>
);



export const SignInIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Arrow entering the hub page */}
    <path d="M4 12h9" />
    <path d="M9 9l4 3-4 3" />

    {/* Hub page */}
    <path d="M15 6h5v12h-5" />
  </svg>
);



export const ModifyOperationsIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Right arrow */}
    <path d="M4 8h12" />
    <path d="M12 5l4 3-4 3" />

    {/* Left arrow */}
    <path d="M20 16H8" />
    <path d="M12 19l-4-3 4-3" />
  </svg>
);



export const FilterIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M14 17H5"></path>
    <path d="M19 7h-9"></path>
    <circle cx="17" cy="17" r="3"></circle>
    <circle cx="7" cy="7" r="3"></circle>
  </svg>
);


export const ToggleOnIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="15" cy="12" r="3"></circle>
    <rect width="20" height="14" x="2" y="5" rx="7"></rect>
  </svg>
);


export const ToggleOffIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="9" cy="12" r="3"></circle>
    <rect width="20" height="14" x="2" y="5" rx="7"></rect>
  </svg>
);



export const ActionsIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Top operation */}
    <path d="M4 7h16" />
    <circle cx="14" cy="7" r="2" />

    {/* Middle operation */}
    <path d="M4 17h16" />
    <circle cx="8" cy="17" r="2" />
  </svg>
);




export const CloseIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    {...props}
  >
    <path
      d="M6 6l12 12M6 18L18 6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const ExclamationIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    {/* Top rounded bar */}
    <path d="M11 3h2c.6 0 1 .4 1 1v11c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1z" />

    {/* Bottom dot */}
    <circle cx="12" cy="19" r="2" />
  </svg>
);



export const Evaluation = ({
  className = "wf-icon text-muted6",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <path d="M9 4V3h6v1" />

    <path d="M9 16v-3" />
    <path d="M12 16V9" />
    <path d="M15 16v-5" />

    <path d="M8 19h8" />
  </svg>
);




export const ModelIcon = ({
  className = "wf-icon text-muted6",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const LabelsIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Tag outline */}
    <path d="
        M3 7
        V11
        L13 21
        A2 2 0 0 0 15.8 21
        L21 15.8
        A2 2 0 0 0 21 13
        L11 3
        H7
        A4 4 0 0 0 3 7
        Z
      " />

    {/* Hole — moved slightly up & right */}
    <circle cx="8.5" cy="8.5" r="2" />
  </svg>
);



// export const VersionsIcon = ({
//   className = "wf-icon",
//   ...props
// }) => (
//   <svg
//     className={className}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     {...props}
//   >
//     <circle cx="6" cy="6" r="2" strokeWidth="2" />
//     <circle cx="6" cy="18" r="2" strokeWidth="2" />
//     <circle cx="18" cy="12" r="2" strokeWidth="2" />

//     <path
//       d="M6 8v8M8 6h6M8 18h6"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );


export const VersionsIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Top-left circle */}
    <circle cx="7" cy="6" r="2" />

    {/* Top-right circle */}
    <circle cx="17" cy="6" r="2" />

    {/* Bottom circle */}
    <circle cx="12" cy="18" r="2" />

    {/* Curved branch connecting them */}
    <path d="M7 8c0 5 5 5 5 5" />
    <path d="M17 8v4" />
  </svg>
);


export const CheckCircleIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Rotated circle (unchanged) */}
    <path
      d="
          M13.5 2.2
          A9.5 9.5 0 1 0 22 11
        "
    />

    {/* Tick moved MORE up + right */}
    <path d="M8.4 11.2 L12.4 15.2 L21.2 5.2" />
  </svg>
);



export const CheckIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Tick moved MORE up + right */}
    <path d="M8.4 11.2 L12.4 15.2 L21.2 5.2" />
  </svg>
);

export const QueuedIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M13.5 2.2 A9.5 9.5 0 1 0 22 11" />
    {/* Clock hands aligned with your tick position */}
    <path d="M12 7 V12 L15 15" />
  </svg>
);

export const TransferTitleIcon = ({
  className = "wf-icon",
  ...props
}) => (
    <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Top arrow: left to right */}
    <path d="M6 9h12" />
    <path d="M15 6l3 3-3 3" />

    {/* Bottom arrow: right to left */}
    <path d="M18 15H6" />
    <path d="M9 12l-3 3 3 3" />
  </svg>
);

export const UpdateIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Top refresh arrow */}
    <path d="M20 7v5h-5" />
    <path d="M19.5 12A7.5 7.5 0 0 0 6.8 6.8" />

    {/* Bottom refresh arrow */}
    <path d="M4 17v-5h5" />
    <path d="M4.5 12A7.5 7.5 0 0 0 17.2 17.2" />
  </svg>
);

export const TerminatedIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export const FailedIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M13.5 2.2 A9.5 9.5 0 1 0 22 11" />
    {/* Error X */}
    <path d="M9 9 L15 15 M15 9 L9 15" />
  </svg>
);


export const PlusIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M12 5v14M5 12h14"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const UserPlusIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <line x1="19" x2="19" y1="8" y2="14"></line>
    <line x1="22" x2="16" y1="11" y2="11"></line>
  </svg>
);



export const InfoIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      strokeWidth="1.5"
    />
    <path
      d="M12 16v-4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8h.01"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const PredictionsIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Centered analytics trend line */}
    <path d="M4 14l6-4 4 3 6-7" />

    {/* Arrow head */}
    <path d="M16 6h4v4" />
  </svg>
);


export const GraphIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M3 3v16a2 2 0 0 0 2 2h16"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 17V9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 17V5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 17v-3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


// List – stacked rows (table / experiment list view)
export const ListIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="9" y1="6" x2="21" y2="6" />
    <line x1="9" y1="12" x2="21" y2="12" />
    <line x1="9" y1="18" x2="21" y2="18" />
    <circle cx="4.5" cy="6" r="1.25" fill="currentColor" stroke="none" />
    <circle cx="4.5" cy="12" r="1.25" fill="currentColor" stroke="none" />
    <circle cx="4.5" cy="18" r="1.25" fill="currentColor" stroke="none" />
  </svg>
);


// Compare – side-by-side panels with bidirectional arrows
export const CompareIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3" y="5" width="7" height="14" rx="1.5" />
    <rect x="14" y="5" width="7" height="14" rx="1.5" />
    <path d="M10 12h4" />
    <path d="M10.5 9.5 12 12 10.5 14.5" />
    <path d="M13.5 9.5 12 12 13.5 14.5" />
  </svg>
);


// Search – magnifying glass
export const SearchIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);


// Chevron – expand / collapse caret
export const ChevronDownIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);


export const DownArrowIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      d="M4 10l12 14 12-14"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BellIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className={className}
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
  </svg>
);



export const GridPlusIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 32"
    {...props}
  >
    {/* Corner brackets */}
    <path
      d="M10 4 H6 a2 2 0 0 0 -2 2 V10"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M22 4 h4 a2 2 0 0 1 2 2 v4"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M10 28 H6 a2 2 0 0 1 -2 -2 V22"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M22 28 h4 a2 2 0 0 0 2 -2 v-4"
      strokeWidth="2.2"
      strokeLinecap="round"
    />

    {/* Plus symbol */}
    <path
      d="M16 11 v10 M11 16 h10"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);



export const GridMinusIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 32"
    {...props}
  >
    {/* Corner brackets */}
    <path
      d="M10 4 H6 a2 2 0 0 0 -2 2 V10"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M22 4 h4 a2 2 0 0 1 2 2 v4"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M10 28 H6 a2 2 0 0 1 -2 -2 V22"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M22 28 h4 a2 2 0 0 0 2 -2 v-4"
      strokeWidth="2.2"
      strokeLinecap="round"
    />

    {/* Minus symbol */}
    <path
      d="M11 16 h10"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);





export const ImagesIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 489.4 489.4"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Rounded corner mask */}
    <defs>
      <mask id="roundedMask">
        <rect width="100%" height="100%" rx="20" ry="20" fill="white" />
      </mask>
    </defs>

    <g mask="url(#roundedMask)">
      <path d="M0,437.8c0,28.5,23.2,51.6,51.6,51.6h386.2c28.5,0,51.6-23.2,51.6-51.6V51.6c0-28.5-23.2-51.6-51.6-51.6H51.6
        C23.1,0,0,23.2,0,51.6C0,51.6,0,437.8,0,437.8z M437.8,464.9H51.6c-14.9,0-27.1-12.2-27.1-27.1v-64.5l92.8-92.8l79.3,79.3
        c4.8,4.8,12.5,4.8,17.3,0l143.2-143.2l107.8,107.8v113.4C464.9,452.7,452.7,464.9,437.8,464.9z M51.6,24.5h386.2
        c14.9,0,27.1,12.2,27.1,27.1v238.1l-99.2-99.1c-4.8-4.8-12.5-4.8-17.3,0L205.2,333.8l-79.3-79.3c-4.8-4.8-12.5-4.8-17.3,0
        l-84.1,84.1v-287C24.5,36.7,36.7,24.5,51.6,24.5z"/>
      <path d="M151.7,196.1c34.4,0,62.3-28,62.3-62.3s-28-62.3-62.3-62.3s-62.3,28-62.3,62.3S117.3,196.1,151.7,196.1z M151.7,96
        c20.9,0,37.8,17,37.8,37.8s-17,37.8-37.8,37.8s-37.8-17-37.8-37.8S130.8,96,151.7,96z"/>
    </g>
  </svg>
);



export const AccuracyIcon2 = ({ className = "wf-accuracy", ...props }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 24"
    {...props}
  >
    <path
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="
       M16 4
       a8 8 0 1 0 0 16
       a8 8 0 1 0 0-16

       M16 10
       a2 2 0 1 0 0 4
       a2 2 0 1 0 0-4

   M16 11
       a1 1 0 1 0 0 2
       a1 1 0 1 0 0-2

       M16 2v4
       M16 18v4
       M11 12H5
       M27 12H21
     "
    />
  </svg>
);



export const VersionsIcon2 = ({
  className = "wf-icon text-secondary",
  height = "20px",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    height={height}
    viewBox="0 0 31 28"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M15.5 3L25 8.5L15.5 13L6 8.5L15.5 3Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 13.5L15.5 18L25 13.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 18.5L15.5 23L25 18.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const LoginIcon = ({
  className = "wf-icon text-secondary",
  height = "20px",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    viewBox="0 0 31 28"
    fill="none"
    {...props}
  >
    <path
      d="M23 3h-9C7.925 3 3 7.925 3 14v0c0 6.075 4.925 11 11 11h9M21 14h7"
      stroke="rgb(26 115 232 / 6%)"
      strokeWidth="6"
      strokeLinecap="round"
    />
  </svg>
);





export const CodeIcon = ({
  className = "wf-icon text-secondary",
  height = "20px",
  stroke = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    viewBox="0 0 44 32"
    fill="none"
    className={className}
    {...props}
  >
    {/* <  (moved LEFT) */}
    <path
      d="M12 8L4 16L12 24"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    {/* /  (moved RIGHT to create gap from <) */}
    <path
      d="M24 6L20 26"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />

    {/* >  (kept closer to /) */}
    <path
      d="M30 8L38 16L30 24"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);




export const AnalyticsIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M5 20v-4M10 20v-8M15 20v-5M20 20V9" />
  </svg>
);

export const RunningIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Speed lines */}
    <path fill="#16A9D5" d="M2 9.2h5.2a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2Z" />
    <path fill="#16A9D5" d="M1 13h4.8a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2Z" />
    <path fill="#16A9D5" d="M3 16.8h3.2a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2Z" />

    {/* Head */}
    <circle fill="#27467F" cx="17.4" cy="4.1" r="2.1" />

    {/* Upper body / back arm */}
    <path
      fill="#27467F"
      d="
        M13.1 6.2
        C13.8 5.5 14.8 5.6 15.4 6.3
        L17.3 8.6
        L19.7 6.3
        C20.2 5.8 21 5.8 21.5 6.3
        C22 6.8 22 7.6 21.5 8.1
        L18.2 11.3
        C17.6 11.9 16.7 11.8 16.1 11.2
        L14.5 9.5
        L12.7 12.1
        L15.8 14
        C16.7 14.5 16.8 15.8 15.9 16.4
        L12.2 18.8
        C11.6 19.2 10.8 19 10.4 18.4
        C10 17.8 10.2 17 10.8 16.6
        L13.1 15.1
        L10.5 13.6
        C9.5 13 9.3 11.8 9.9 10.9
        Z
      "
    />

    {/* Rear arm */}
    <path
      fill="#27467F"
      d="
        M12.8 6.5
        L10.4 5.2
        L8.3 7.2
        C7.8 7.7 7 7.7 6.5 7.2
        C6 6.7 6 5.9 6.5 5.4
        L9.2 2.9
        C9.7 2.4 10.4 2.3 11 2.7
        L14.1 4.5
        Z
      "
    />

    {/* Extended front leg */}
    <path
      fill="#27467F"
      d="
        M11.5 12.8
        L9.7 16.2
        L6.3 20.2
        C5.8 20.8 4.9 20.9 4.3 20.4
        C3.7 19.9 3.7 19 4.2 18.4
        L8 13.8
        L9.5 11.2
        Z
      "
    />
  </svg>
);


export const LeaderboardIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 21V9H15V21H9Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M3 21V13H9V21H3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M15 21V11H21V21H15Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M12 3L13 5L15.2 5.3L13.6 6.8L14 9L12 8L10 9L10.4 6.8L8.8 5.3L11 5L12 3Z"
      fill="currentColor"
    />
  </svg>
);





export const TableIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Square outline */}
    <rect
      x="3"
      y="3"
      width="18"
      height="18"
      rx="4"
      ry="4"
    />

    {/* Bold top line (4px height) */}
    <rect
      x="3"
      y="3"
      width="18"
      height="4"
      fill="currentColor"
      stroke="none"
    />

    {/* Minus line */}
    <line
      x1="8"
      y1="12"
      x2="16"
      y2="12"
    />
  </svg>
);



export const CompatibilityIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="square"
    {...props}
  >
    {/* Top U  |_|
       shifted upward slightly */}
    <path d="M9 5v3h6V5" />

    {/* Left middle bars
       shifted left slightly */}
    <path d="M6 10h-2" />
    <path d="M6 14h-2" />
    <path d="M6 10v4" />

    {/* Right middle bars
       shifted right slightly */}
    <path d="M18 10h2" />
    <path d="M18 14h2" />
    <path d="M18 10v4" />

    {/* Bottom reverse-U  |‾‾|
       shifted downward slightly */}
    <path d="M9 19v-3h6v3" />
  </svg>
);




export const AccuracyIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path
      d="
              M12 3
              C12.4 3 12.8 3.2 13 3.6
              L14.8 7.3
              C15 7.7 15.4 8 15.9 8.1
              L19.9 8.7
              C20.7 8.8 21.1 9.7 20.6 10.3
              L17.7 13.4
              C17.4 13.8 17.3 14.3 17.4 14.8
              L18.1 18.8
              C18.2 19.6 17.4 20.2 16.7 19.9
              L13.1 18.2
              C12.7 18 12.3 18 11.9 18.2
              L8.3 19.9
              C7.6 20.2 6.8 19.6 6.9 18.8
              L7.6 14.8
              C7.7 14.3 7.6 13.8 7.3 13.4
              L4.4 10.3
              C3.9 9.7 4.3 8.8 5.1 8.7
              L9.1 8.1
              C9.6 8 10 7.7 10.2 7.3
              L12 3.6
              C12.2 3.2 12.6 3 13 3
              Z
          "
    />
  </svg>
);


export const RoundedClockIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Outer rounded circle */}
    <circle cx="12" cy="12" r="8" />

    {/* Clock hands */}
    <path d="M12 8v4l2.5 2.5" />
  </svg>
);


export const HistoryIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
  </svg>
);




export const SendMessageIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="
      M2.5 4
      Q2 3.5 2.6 3.2
      L21 11.6
      Q22 12 21 12.4
      L2.6 20.8
      Q2 20.5 2.5 20
      L4.5 13.3
      Q4.7 12.7 5.3 12.7
      L13.5 12
      L5.3 11.3
      Q4.7 11.3 4.5 10.7
      Z
    " />
  </svg>
);



export const PlusCircleIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="8" x2="12" y2="16" />
    <line x1="8" y1="12" x2="16" y2="12" />
  </svg>
);

export const SingupIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
    <polyline points="10 17 15 12 10 7"></polyline>
    <line x1="15" y1="12" x2="3" y2="12"></line></svg>
);


export const TokensPerSecondIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    viewBox="0 0 24 24"
    className={className}
  >
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
  </svg>
);


export const RegisterIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  ><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <line x1="19" y1="8" x2="19" y2="14">
    </line><line x1="22" y1="11" x2="16" y2="11"></line></svg>
);




export const ChipsetIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 20v2" />
    <path d="M12 2v2" />
    <path d="M17 20v2" />
    <path d="M17 2v2" />
    <path d="M2 12h2" />
    <path d="M2 17h2" />
    <path d="M2 7h2" />
    <path d="M20 12h2" />
    <path d="M20 17h2" />
    <path d="M20 7h2" />
    <path d="M7 20v2" />
    <path d="M7 2v2" />
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <rect x="8" y="8" width="8" height="8" rx="1" />
  </svg>
);


export const ChipsetIcon2 = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="7" y="7" width="10" height="10" rx="2" />
    <path d="M4 10h3M4 14h3M17 10h3M17 14h3" />
    <path d="M10 4v3M14 4v3M10 17v3M14 17v3" />
  </svg>
);



export const QueueChipIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M19 11H5" />
    <path d="M21 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2" />
    <path d="M19 11V9a2 2 0 00-2-2" />
    <path d="M5 11V9a2 2 0 012-2" />
    <path d="M7 7V5a2 2 0 012-2h6a2 2 0 012 2v2" />
    <path d="M7 7h10" />
  </svg>
);



export const ChatIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Chat bubble */}
    <path
      d="M13.3 3.45
         c-4.97 0-9 3.58-9 8
         0 2.52 1.31 4.77 3.38 6.25
         L6 21l3.38-1.88
         c.84.19 1.72.28 2.62.28
         4.97 0 9-3.58 9-8
         s-4.03-8-9-8z"
    />

    {/* Lightning bolt */}
    <path
      d="M9 14
         l3-4
         2 2
         3-4"
    />
  </svg>
);



export const RadarIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
  </svg>
);




export const DeviceIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >

    <rect x="4" y="6" width="16" height="12" rx="2" />


    <rect x="9" y="9" width="6" height="6" rx="1" />


    <line x1="4" y1="10" x2="2" y2="10" />
    <line x1="4" y1="14" x2="2" y2="14" />

    <line x1="22" y1="10" x2="20" y2="10" />
    <line x1="22" y1="14" x2="20" y2="14" />
  </svg>
);



export const UploadIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Arrow */}
    <path d="M12 4v10" />
    <path d="M8 8l4-4 4 4" />

    {/* Tray */}
    <path d="M4 14v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-3" />
  </svg>
);




export const ImageIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
    <circle cx="9" cy="9" r="2"></circle>
    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
  </svg>
);



export const MusicIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 18V5l12-2v13"></path>
    <circle cx="6" cy="18" r="3"></circle>
    <circle cx="18" cy="16" r="3"></circle>
  </svg>
);



export const ReloadIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8">
    </path><path d="M3 3v5h5">
    </path>
  </svg>
);


export const CustomisePlanIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path>
    <path d="M20 2v4"></path>
    <path d="M22 4h-4"></path>
    <circle cx="4" cy="20" r="2"></circle>
  </svg>
);


export const VideoIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Camera side block (play/record shape) */}
    <path d="M16 13l5.2 3.5a.5.5 0 0 0 .8-.4V7.9a.5.5 0 0 0-.75-.43L16 10.5" />

    {/* Main video frame */}
    <rect x="2" y="6" width="14" height="12" rx="2" />
  </svg>
);


export const GearIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

/** Light outline lock for security / password UI */
export const LockIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="4.5" y="10.5" width="15" height="11" rx="2" />
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
    <circle cx="12" cy="15.5" r="1.25" />
  </svg>
);

/** Simple admin cap (mortarboard) — clear at menu size */
export const AdminConsoleIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3 9.5L12 4.5l9 5-9 5-9-5z" />
    <path d="M7 11.5v4.2c0 1.3 2.2 2.3 5 2.3s5-1 5-2.3v-4.2" />
    <path d="M21 9.5v5.2" />
    <circle cx="21" cy="15.5" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);


export const NetworkIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Outer circle */}
    <circle cx="12" cy="12" r="10" />

    {/* Vertical ellipse (longitude) */}
    <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20" />

    {/* Horizontal line (equator) */}
    <path d="M2 12h20" />
  </svg>
);




export const PlatformIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Top bar / header */}
    <path d="M4 6h16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />

    {/* Bottom platform section */}
    <path d="M4 14h16a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2z" />

    {/* Small UI indicator dots (matching your SVG’s .01 dots) */}
    <path d="M16 9h.01" />
    <path d="M16 17h.01" />
  </svg>
);

/** Light factory / plant building – sawtooth roof outline */
export const FactoryIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 21h18" />
    <path d="M5 21V10l4 3V10l4 3V8l6-2v15" />
    <path d="M9 21v-3" />
    <path d="M13 21v-3" />
    <path d="M17 21v-5" />
  </svg>
);

/** Light office / plant building outline */
export const PlantIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 21h16" />
    <path d="M6 21V8l6-4 6 4v13" />
    <path d="M10 12h.01" />
    <path d="M14 12h.01" />
    <path d="M10 16h.01" />
    <path d="M14 16h.01" />
    <path d="M11 21v-3h2v3" />
  </svg>
);

/** Simple camera outline for station cards */
export const CameraIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3.5" />
  </svg>
);

/** Production line – linked nodes */
export const LineIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="5" cy="12" r="2.5" />
    <circle cx="19" cy="12" r="2.5" />
    <path d="M7.5 12h9" />
  </svg>
);

export const UserIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >

    <path d="M16 9h.01" />
    <path d="M16 17h.01" />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

export const UserGroupIcon = ({ className = 'w-6 h-6' }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);

export const CreditCardIcon = ({ className = 'w-6 h-6' }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
    />

  </svg>
);

export const GlobeAltIcon = ({ className = 'w-8 h-8' }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path>
    <path d="M2 12h20"></path>
  </svg>
);


export const HotKeysIcon = ({ className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path d="M10 8h.01"></path>
    <path d="M12 12h.01"></path>
    <path d="M14 8h.01"></path>
    <path d="M16 12h.01"></path>
    <path d="M18 8h.01"></path>
    <path d="M6 8h.01"></path>
    <path d="M7 16h10"></path>
    <path d="M8 12h.01"></path>
    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
  </svg>
);

export const Storageicon = ({ className = 'w-8 h-8' }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <line x1="22" x2="2" y1="12" y2="12"></line>
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
    <line x1="6" x2="6.01" y1="16" y2="16"></line>
    <line x1="10" x2="10.01" y1="16" y2="16"></line>
  </svg>
);



export const DotsIcon = ({
  className = "wf-icon text-secondary",
  width = "20px",
  height = "20px",
  ...props
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    <circle cx="9" cy="12" r="1"></circle>
    <circle cx="9" cy="5" r="1"></circle>
    <circle cx="9" cy="19" r="1"></circle>
    <circle cx="15" cy="12" r="1"></circle>
    <circle cx="15" cy="5" r="1"></circle>
    <circle cx="15" cy="19" r="1"></circle>
  </svg>
);



export const EyeIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Eye outline */}
    <path d="M1.5 12s4-7 10.5-7 10.5 7 10.5 7-4 7-10.5 7S1.5 12 1.5 12Z" />

    {/* Pupil */}
    <circle cx="12" cy="12" r="3" />
  </svg>
);


export const MenuCardIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  ><rect width="7" height="9" x="3" y="3" rx="1"></rect><rect width="7" height="5" x="14" y="3" rx="1"></rect><rect width="7" height="9" x="14" y="12" rx="1"></rect><rect width="7" height="5" x="3" y="16" rx="1"></rect></svg>
);

/** Light outline lightbulb — solutions / ideas */
export const LightbulbIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z" />
  </svg>
);

/** Light outline document — docs nav */
export const DocsFileIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M9 13h6" />
    <path d="M9 17h6" />
  </svg>
);

/** Connected nodes — hub nav / landing */
export const HubNodesIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* spokes */}
    <path d="M13.7 10.3 18.6 5.5" />
    <path d="M10.3 10.7 6.6 7.6" />
    <path d="M14.2 12.7 18.5 13.7" />
    <path d="M10.6 13.8 7.6 18.2" />
    <path d="M13.4 14.1 16.8 18.8" />
    {/* nodes */}
    <circle cx="12" cy="12" r="2.35" />
    <circle cx="20" cy="4.2" r="1.75" />
    <circle cx="5.1" cy="6.3" r="1.75" />
    <circle cx="20.2" cy="14" r="1.75" />
    <circle cx="6.4" cy="19.7" r="1.75" />
    <circle cx="18.1" cy="20.5" r="1.75" />
  </svg>
);


export const EyeOffIcon = ({
  className = "wf-icon",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Eye outline */}
    <path d="M1.5 12s4-7 10.5-7 10.5 7 10.5 7-4 7-10.5 7S1.5 12 1.5 12Z" />

    {/* Pupil */}
    <circle cx="12" cy="12" r="3" />

    {/* Slash */}
    <line x1="3" y1="3" x2="21" y2="21" />
  </svg>
);

/**
 * Convenience map: lifecycle name -> icon component
 */
export const lifecycleIcons = {
  "Data Management": DatasetIcon,
  "Data Labelling": LabelsIcon,
  "Model Training": ModelEvaluationIcon,
  "Model Evaluation": HistoryIcon,
  "Model Deployment": RadarIcon,
  "Full Cycle": FullCycleIcon,
};


// WorkflowIcons.jsx
export const categoryIconMap = {
  core: MenuIcon,
  data: DatasetIcon,
  label: LabelsIcon,
  labeling: LabelsIcon,
  training: ModelEvaluationIcon,
  evaluation: HistoryIcon,
  deployment: HistoryIcon,
  solution: TableIcon,
  solutions: TableIcon,
  monitoring: ModelTrainingIcon,
};

export const TrashIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    {/* Top line */}
    <path
      d="M5 7H19"
      strokeWidth="1.8"
      strokeLinecap="round"
    />

    {/* Lid handle */}
    <path
      d="M10 7V5.5C10 4.7 10.7 4 11.5 4H12.5C13.3 4 14 4.7 14 5.5V7"
      strokeWidth="1.8"
      strokeLinecap="round"
    />

    {/* Trash body */}
    <path
      d="M7 7L7.8 19C7.9 20.1 8.8 21 9.9 21H14.1C15.2 21 16.1 20.1 16.2 19L17 7"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />

    {/* Inner vertical lines */}
    <path
      d="M10.5 11V17M13.5 11V17"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const PauseIcon = ({
  className = "wf-icon text-secondary",
  ...props
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    {...props}
  >
    {/* Pause circle */}
    <circle
      cx="12"
      cy="12"
      r="8.5"
      strokeWidth="1.8"
    />

    {/* Pause bars */}
    <path
      d="M9.5 8.5V15.5M14.5 8.5V15.5"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* ── Device farm isometric card icons (layered for hover) ── */

const DeviceIsoDefs = ({ uid }) => (
  <defs>
    <linearGradient id={`${uid}-baseTop`} x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stopColor="#F7F9FC" />
      <stop offset="100%" stopColor="#E4E9F0" />
    </linearGradient>
    <linearGradient id={`${uid}-baseSide`} x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stopColor="#D8DEE8" />
      <stop offset="100%" stopColor="#B8C0CE" />
    </linearGradient>
    <linearGradient id={`${uid}-deck`} x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stopColor="#3A455C" />
      <stop offset="100%" stopColor="#1E2636" />
    </linearGradient>
    <linearGradient id={`${uid}-blue`} x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stopColor="#5BB8FF" />
      <stop offset="100%" stopColor="#2F86F0" />
    </linearGradient>
    <linearGradient id={`${uid}-blueSide`} x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%" stopColor="#3A9AE8" />
      <stop offset="100%" stopColor="#1F6FC0" />
    </linearGradient>
    <filter id={`${uid}-shadow`} x="-30%" y="-30%" width="160%" height="160%">
      <feDropShadow dx="0" dy="4" stdDeviation="3.5" floodColor="#0F172A" floodOpacity="0.18" />
    </filter>
  </defs>
);

const DeviceIsoBaseChassis = ({ uid }) => (
  <g className="device-iso-base">
    <ellipse className="device-iso-shadow" cx="80" cy="118" rx="42" ry="7" fill="#0F172A" opacity="0.12" />
    <path d="M38 88 L80 108 L80 122 L38 102 Z" fill={`url(#${uid}-baseSide)`} />
    <path d="M122 88 L80 108 L80 122 L122 102 Z" fill="#C5CCD8" />
    <path d="M38 88 L80 68 L122 88 L80 108 Z" fill={`url(#${uid}-baseTop)`} />
    <path d="M52 90 L80 76 L108 90 L80 104 Z" fill="#CFE0F8" opacity="0.95" />
    <path d="M52 90 L80 104 L80 108 L52 94 Z" fill="#9BB8E0" opacity="0.55" />
    <path d="M44 94 h10 M44 97 h10 M44 100 h10" stroke="#A8B0BE" strokeWidth="1.2" strokeLinecap="round" />
    <path d="M106 94 h10 M106 97 h10 M106 100 h10" stroke="#A8B0BE" strokeWidth="1.2" strokeLinecap="round" />
  </g>
);

export const DeviceSiliconIsoIcon = ({
  className = "device-iso-icon",
  ...props
}) => {
  const uid = `dsi-${React.useId().replace(/:/g, "")}`;
  return (
    <svg
      className={className}
      viewBox="0 0 160 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <DeviceIsoDefs uid={uid} />
      <DeviceIsoBaseChassis uid={uid} />
      <g className="device-iso-deck" filter={`url(#${uid}-shadow)`}>
        <path d="M50 72 L80 56 L110 72 L80 88 Z" fill={`url(#${uid}-deck)`} />
        <path d="M50 72 L80 88 L80 94 L50 78 Z" fill="#151B28" />
        <path d="M110 72 L80 88 L80 94 L110 78 Z" fill="#0F1420" />
        <path
          d="M62 70 L72 65 M88 65 L98 70 M70 78 L80 73 L90 78"
          stroke="#6B7A94"
          strokeWidth="1.2"
          strokeLinecap="round"
          opacity="0.7"
        />
      </g>
      <g className="device-iso-accent">
        <path d="M68 62 L80 55 L92 62 L80 69 Z" fill={`url(#${uid}-blue)`} />
        <path d="M68 62 L80 69 L80 74 L68 67 Z" fill={`url(#${uid}-blueSide)`} />
        <path d="M92 62 L80 69 L80 74 L92 67 Z" fill="#1E6DC4" />
        <path d="M94 54 L100 51 L106 54 L100 57 Z" fill={`url(#${uid}-blue)`} />
        <path d="M98 48 L102 46 L106 48 L102 50 Z" fill={`url(#${uid}-blue)`} />
      </g>
    </svg>
  );
};

export const DeviceVisionIsoIcon = ({
  className = "device-iso-icon",
  ...props
}) => {
  const uid = `dvi-${React.useId().replace(/:/g, "")}`;
  return (
    <svg
      className={className}
      viewBox="0 0 160 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <DeviceIsoDefs uid={uid} />
      <DeviceIsoBaseChassis uid={uid} />
      <g className="device-iso-deck" filter={`url(#${uid}-shadow)`}>
        <path d="M50 72 L80 56 L110 72 L80 88 Z" fill={`url(#${uid}-deck)`} />
        <path d="M50 72 L80 88 L80 94 L50 78 Z" fill="#151B28" />
        <path d="M110 72 L80 88 L80 94 L110 78 Z" fill="#0F1420" />
        <path d="M58 68 L64 65 L70 68 L64 71 Z" fill="#C9D2E0" />
        <path d="M90 64 L98 60 L106 64 L98 68 Z" fill="#AEB8C8" />
      </g>
      <g className="device-iso-accent">
        <ellipse cx="80" cy="64" rx="14" ry="9" fill={`url(#${uid}-blue)`} />
        <ellipse cx="80" cy="62" rx="14" ry="9" fill="#7AC4FF" />
        <path
          d="M74 60c0-2.2 2.6-4 6-4s6 1.8 6 4c1.4 0 2.5 1 2.5 2.2S87.4 64.4 86 64.4H74c-1.4 0-2.5-1-2.5-2.2S72.6 60 74 60Z"
          fill="#fff"
          opacity="0.95"
        />
      </g>
    </svg>
  );
};

export const DeviceAcceleratorIsoIcon = ({
  className = "device-iso-icon",
  ...props
}) => {
  const uid = `dai-${React.useId().replace(/:/g, "")}`;
  return (
    <svg
      className={className}
      viewBox="0 0 160 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <DeviceIsoDefs uid={uid} />
      <DeviceIsoBaseChassis uid={uid} />
      <g className="device-iso-deck" filter={`url(#${uid}-shadow)`}>
        <path d="M48 58 L104 42 L118 56 L62 72 Z" fill={`url(#${uid}-deck)`} />
        <path d="M48 58 L62 72 L62 86 L48 72 Z" fill="#151B28" />
        <path d="M118 56 L62 72 L62 86 L118 70 Z" fill="#0F1420" />
        <path d="M58 66 L72 58 L92 64 L78 72 Z" fill="#4A5670" />
        <text
          x="86"
          y="58"
          fill="#F8FAFC"
          fontSize="9"
          fontFamily="system-ui, sans-serif"
          fontWeight="700"
          textAnchor="middle"
        >
          GPU
        </text>
      </g>
      <g className="device-iso-accent">
        <circle cx="92" cy="52" r="9" fill={`url(#${uid}-blue)`} />
        <circle cx="92" cy="52" r="5.5" fill="#EAF5FF" opacity="0.35" />
        <circle cx="92" cy="52" r="2.5" fill="#fff" />
        <path d="M54 78 L70 70 L74 74 L58 82 Z" fill={`url(#${uid}-blue)`} />
      </g>
    </svg>
  );
};

export const DeviceComputeIsoIcon = ({
  className = "device-iso-icon",
  ...props
}) => {
  const uid = `dci-${React.useId().replace(/:/g, "")}`;
  return (
    <svg
      className={className}
      viewBox="0 0 160 140"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <DeviceIsoDefs uid={uid} />
      <DeviceIsoBaseChassis uid={uid} />
      <g className="device-iso-deck" filter={`url(#${uid}-shadow)`}>
        <path d="M50 72 L80 56 L110 72 L80 88 Z" fill={`url(#${uid}-deck)`} />
        <path d="M50 72 L80 88 L80 94 L50 78 Z" fill="#151B28" />
        <path d="M110 72 L80 88 L80 94 L110 78 Z" fill="#0F1420" />
        <path d="M62 66 L72 61 L78 66 L68 71 Z" fill="#5A657A" />
        <path d="M78 62 L88 57 L94 62 L84 67 Z" fill="#5A657A" />
        <path d="M66 74 L76 69 L82 74 L72 79 Z" fill="#5A657A" />
      </g>
      <g className="device-iso-accent">
        <path d="M82 70 L92 65 L98 70 L88 75 Z" fill={`url(#${uid}-blue)`} />
        <path d="M82 70 L88 75 L88 79 L82 74 Z" fill={`url(#${uid}-blueSide)`} />
        <path d="M98 70 L88 75 L88 79 L98 74 Z" fill="#1E6DC4" />
        <path d="M86 68 h5 M88.5 65.5 v5" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" />
      </g>
    </svg>
  );
};

export const AiInsightsIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path d="M10.1 2.7c.18-.62 1.06-.62 1.24 0l.64 2.2a4.4 4.4 0 0 0 3 3l2.2.64c.62.18.62 1.06 0 1.24l-2.2.64a4.4 4.4 0 0 0-3 3l-.64 2.2c-.18.62-1.06.62-1.24 0l-.64-2.2a4.4 4.4 0 0 0-3-3l-2.2-.64c-.62-.18-.62-1.06 0-1.24l2.2-.64a4.4 4.4 0 0 0 3-3l.64-2.2Z" />
    <path d="M18.35 14.75c.1-.36.62-.36.72 0l.3 1.03a2.25 2.25 0 0 0 1.53 1.53l1.03.3c.36.1.36.62 0 .72l-1.03.3a2.25 2.25 0 0 0-1.53 1.53l-.3 1.03c-.1.36-.62.36-.72 0l-.3-1.03a2.25 2.25 0 0 0-1.53-1.53l-1.03-.3c-.36-.1-.36-.62 0-.72l1.03-.3a2.25 2.25 0 0 0 1.53-1.53l.3-1.03Z" />
  </svg>
);

/** Thin play triangle — inspection / media controls */
export const PlayIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M8 6.5v11l9-5.5-9-5.5Z" />
  </svg>
);

/** Thin pause bars — inspection controls */
export const PauseBarsIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M9 6.5v11" />
    <path d="M15 6.5v11" />
  </svg>
);

/** Thin stop / end — session controls */
export const StopSquareIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <rect x="6.5" y="6.5" width="11" height="11" rx="1.5" />
  </svg>
);

/** Thin skip-next — next inspection */
export const SkipNextIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M6.5 6.5v11l8.5-5.5-8.5-5.5Z" />
    <path d="M17.5 6.5v11" />
  </svg>
);

/** Thin warning triangle — criteria / alerts */
export const WarningTriangleIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </svg>
);

/** Thin clock — runtime / duration */
export const ClockIcon = ({ className = "wf-icon", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);
